/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddendumCodeUIDTOV0 } from './addendumCodeUIDTOV0';


export interface AddendumUIDTOV0 { 
    addendumNumbers?: Array<AddendumCodeUIDTOV0>;
    /**
     * Cavity fill is recommended
     */
    cavityFillRecommended?: boolean;
    /**
     * Stone walls present, not insulated
     */
    stoneWalls?: boolean;
    /**
     * System build present
     */
    systemBuild?: boolean;
    /**
     * Dwelling has access issues for cavity wall insulation. Include only when at least one of Cavity-Fill-Recommended, Stone-Walls, System-Build is also present 
     */
    accessIssues?: boolean;
    /**
     * Dwelling may be exposed to wind-driven rain. Include only when at least one of Cavity-Fill-Recommended, Stone-Walls, System-Build is also present 
     */
    highExposure?: boolean;
    /**
     * Dwelling may have narrow cavities. Include only when Cavity-Fill-Recommended is also present 
     */
    narrowCavities?: boolean;
}

